import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// action types

export const GET_CATEGORIES = "getCategories";
export const GET_CATEGORY = "getCategory";
export const ADD_CATEGORY = "addCategory";
export const GET_SELECT = "getSelect";
export const GET_SELECT_SUB = "getSelectSub";
export const UPDATE_CATEGORY = "updateCategory";
export const UPDATE_SUB_CATEGORY = "updateSubCategory";
export const UPDATE_SUB_SUB_CATEGORY = "updateSubSubCategory";
export const SORT_CATEGORY = "SortCategory";
export const SORT_SEB_CATEGORY = "SortSubCategory";
export const SORT_SEB_SUB_CATEGORY = "SortSubSubCategory";
export const DELETE_CATEGORY = "deleteCategory";
export const DELETE_SUB_CATEGORY = "deleteSubCategory";
export const DELETE_SUB_SUB_CATEGORY = "deleteSubSubCategory";
export const GET_CATEGORIES_TRASHED = "getCategoryTrashed";
export const RESTORE_CATEGORY = "restoreCategory";
export const RESTORE_SUB_CATEGORY = "restoreSubCategory";
export const GET_NEW_CATEGORY = "GetNewCategort";

// mutation types
export const SET_CATEGORY_ERROR = "setErrors";
export const SET_CATEGORIES = "setCategories";
export const SET_CATEGORY = "setCategory";
export const GET_SUB_CATEGORY = "setSubCategory";
export const GET_SUB_SUB_CATEGORY = "setSubSubCategory";
export const SET_CATEGORY_LOAD = "setCategoryLoad";
export const SET_SELECT = "setSelect";
export const SET_SELECT_SUB = "setSelectSub";
export const SET_TRASHED = "setTrashed";
export const SET_NEW_CATEGORY = "setNewCategory";


const state = {
    errors: {},
    categories: [],
    subCategories: [],
    load: false,
    category: {
        name:'',
        code:'',
        description:'',
        image: null,
        icon: '',
        filters: [],
        category_id: null,
        sub_category_id: null

    },
    selectCategory: {},
    selectSubCategory: {},
    trashed: {
        categories: {},
        subCategories: {}
    },
    filters: []

};


const getters = {

    gettersCategories(state) {
        return state.categories;
    },

    getSelectSubCategories(state) {
        return state.subCategories;
    },

    gettersCategory(state) {
        return state.category;
    },

    gettersFilters(state){
        return state.filters;
    },

    errorsCategory(){
        return state.errors;
    },
    getCategoryLoad(){
        return state.load;
    },
    getSelectCategory(){
        return state.selectCategory;
    },
    getSelectSubCategory(){
        return state.selectSubCategory;
    },
    gettersTrashedCategories(){
        return state.trashed;
    }
};

const actions = {

    [GET_CATEGORIES](context) {
        return new Promise((resolve, reject) => {
            context.commit(SET_CATEGORY_LOAD, true);
            context.commit(SET_CATEGORY_ERROR, {});
            ApiService.get("/categories")
                .then(({ data }) => {
                    context.commit(SET_CATEGORIES, data.categories);
                    context.commit(SET_CATEGORY_LOAD, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    context.commit(SET_CATEGORY_LOAD, false);
                    reject(response);
                });
        });
    },


    [GET_NEW_CATEGORY](context) {
        return new Promise((resolve, reject) => {
            context.commit(SET_CATEGORY_LOAD, true);
            context.commit(SET_CATEGORY_ERROR, {});
            ApiService.get("/new-category/filters")
                .then(({ data }) => {
                    context.commit(SET_CATEGORY, data);
                    context.commit(SET_CATEGORY_LOAD, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    context.commit(SET_CATEGORY_LOAD, false);
                    reject(response);
                });
        });
    },


    [ADD_CATEGORY](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_CATEGORY_ERROR, {});
            ApiService.post("/categories/store", data)
                .then(({ data }) => {
                    context.dispatch(GET_CATEGORIES);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response.status === 422){
                        context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    }
                    reject(response);
                });
        });
    },

    [GET_SELECT](context) {
        return new Promise((resolve, reject) => {
            ApiService.get("/categories/add")
                .then(({ data }) => {
                    context.commit(SET_SELECT, data.selectCategories);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },

    [GET_SELECT_SUB](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get("/selects-sub-categories", id)
                .then(({ data }) => {
                    context.commit(SET_SELECT_SUB, data.selectSubCategories);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },

    [GET_CATEGORY](context, id) {
        context.commit(SET_CATEGORY_LOAD, true);
        context.commit(SET_CATEGORY_ERROR, {});
        return new Promise((resolve, reject) => {
        ApiService.get("/categories/edit", id)
            .then(({ data }) => {
                context.commit(SET_CATEGORY, data);
                context.commit(SET_CATEGORY_LOAD, false);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit(SET_CATEGORY_ERROR, response.data.errors);
                context.commit(SET_CATEGORY_LOAD, false);
                reject(response);
            });
        });
    },

    [GET_SUB_CATEGORY](context, id) {
        context.commit(SET_CATEGORY_ERROR, {});
        context.commit(SET_CATEGORY_LOAD, true);
        return new Promise((resolve, reject) => {
        ApiService.get("/sub-categories/edit", id)
            .then(({ data }) => {
                context.commit(SET_CATEGORY, data);
                context.commit(SET_CATEGORY_LOAD, false);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit(SET_CATEGORY_ERROR, response.data.errors);
                context.commit(SET_CATEGORY_LOAD, false);
                reject(response);
            });
        });
    },

    [GET_SUB_SUB_CATEGORY](context, id) {
        context.commit(SET_CATEGORY_ERROR, {});
        context.commit(SET_CATEGORY_LOAD, true);
        return new Promise((resolve, reject) => {
            ApiService.get("/sub-sub-categories/edit", id)
                .then(({ data }) => {
                    context.commit(SET_CATEGORY, data);
                    context.commit(SET_CATEGORY_LOAD, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    context.commit(SET_CATEGORY_LOAD, false);
                    reject(response);
                });
        });
    },


    [UPDATE_CATEGORY](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_CATEGORY_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/categories/update", data.id, data.category)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});

                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_CATEGORY_ERROR, response.data.errors);
                        }

                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [UPDATE_SUB_CATEGORY](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_CATEGORY_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/sub-categories/update", data.id, data.category)
                    .then(({ data }) => {
                        context.commit(SET_CATEGORY_ERROR, {});
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        if (response.status === 422){
                            context.commit(SET_CATEGORY_ERROR, response.data.errors);
                        }
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [UPDATE_SUB_SUB_CATEGORY](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_CATEGORY_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/sub-sub-categories/update", data.id, data.category)
                    .then(({ data }) => {
                        context.commit(SET_CATEGORY_ERROR, {});
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        if (response.status === 422){
                            context.commit(SET_CATEGORY_ERROR, response.data.errors);
                        }
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },


    [SORT_CATEGORY](context, categories) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/categories/sort", '', {categories: categories})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [SORT_SEB_CATEGORY](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/sub-categories/sort", data.id, {categories: data.categories})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});

                    })
                    .catch(({ response }) => {
                        reject(response);
                        context.commit(SET_CATEGORY_ERROR, response.data.errors);

                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [SORT_SEB_SUB_CATEGORY](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/sub-sub-categories/sort", data.id, {categories: data.categories})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});

                    })
                    .catch(({ response }) => {
                        reject(response);
                        context.commit(SET_CATEGORY_ERROR, response.data.errors);

                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },


    [DELETE_CATEGORY](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/category/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


    [DELETE_SUB_CATEGORY](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/sub-category/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [DELETE_SUB_SUB_CATEGORY](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/sub-sub-category/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [GET_CATEGORIES_TRASHED](context) {
        return new Promise((resolve, reject) => {
            context.commit(SET_CATEGORY_LOAD, true);
            context.commit(SET_CATEGORY_ERROR, {});
            ApiService.get("/categories-trashed")
                .then(({ data }) => {
                    context.commit(SET_TRASHED, data);
                    context.commit(SET_CATEGORY_LOAD, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_CATEGORY_ERROR, response.data.errors);
                    context.commit(SET_CATEGORY_LOAD, false);
                    reject(response);
                });
        });
    },


    [RESTORE_CATEGORY](context, id){
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.get("/category/restore", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [RESTORE_SUB_CATEGORY](context, id){
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.get("/sub-category/restore", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CATEGORY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


};

const mutations = {
    [SET_CATEGORY_ERROR](state, error) {
        state.errors = error;
    },

    [SET_CATEGORIES](state, categories) {
        state.categories = categories;
    },

    [SET_CATEGORY](state, dara) {
        state.category = dara.category;
        state.filters = dara.filters;
        state.subCategories = dara.rootCategories;
    },

    [SET_CATEGORY_LOAD](state, load) {
        state.load = load;
    },

    [SET_SELECT](state, select) {
        state.selectCategory = select;
    },

    [SET_SELECT_SUB](state, select) {
        state.subCategories = select;
    },

    [SET_TRASHED](state, data) {

        state.trashed.categories = data.categories;
        state.trashed.subCategories = data.subCategories;

    },

    [SET_NEW_CATEGORY](state){

        state.category = {
            name:'',
            code:'',
            description:'',
            image: null,
            icon: '',
            filters: [],
            category_id: null,
            sub_category_id: null
        }


    }


};

export default {
    state,
    actions,
    mutations,
    getters
};
